import { render, staticRenderFns } from "./SpeakerTest.vue?vue&type=template&id=200b9bbf&scoped=true&"
import script from "./SpeakerTest.vue?vue&type=script&lang=js&"
export * from "./SpeakerTest.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerTest.vue?vue&type=style&index=0&id=200b9bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b9bbf",
  null
  
)

export default component.exports